import React from "react";
import { Card, Space } from "antd";
import HeadingSubHeading from "../../../../components/ViewHeading/HeadingSubHeading";

const EmployeeDefaults = () => {
    return (
        <Card title={<HeadingSubHeading titleProps={{ level: 5 }} title="Employee Defaults" subTitle="Set default values for employees" />}>
            <Space direction="vertical" size={[30, 30]}>
                <HeadingSubHeading titleProps={{ level: 5 }} title="Worker Type" subTitle="Permanent" />
                <HeadingSubHeading titleProps={{ level: 5 }} title="Time Type" subTitle="Full Time" />
            </Space>
        </Card>
    );
}

export default EmployeeDefaults;